import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, CircularProgress, Alert, Button } from '@mui/material';
import CheckCircle from '@mui/icons-material/CheckCircle';
import Error from '@mui/icons-material/Error';
import { useTranslation } from 'react-i18next';
import { AI_API_URL } from '../constants';

/**
 * 이메일 액션 처리 페이지 (이메일 인증, 비밀번호 재설정 등)
 */
const EmailActionPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [actionType, setActionType] = useState('');

  useEffect(() => {
    const handleEmailAction = async () => {
      const urlParams = new URLSearchParams(location.search);
      const mode = urlParams.get('mode');

      // 커스텀 이메일 인증 시스템으로 변경됨
      setActionType('이메일 인증');
      setError('이 링크는 더 이상 지원되지 않습니다. 새로운 이메일 인증 시스템을 사용해주세요.');
      setLoading(false);
    };

    handleEmailAction();
  }, [location, navigate]);

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoLogin = () => {
    navigate('/?login=true');
  };

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        bgcolor="background.default"
      >
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center', maxWidth: 400 }}>
          <CircularProgress size={60} sx={{ mb: 2 }} />
          <Typography variant="h6" gutterBottom>
            {actionType} 처리 중...
          </Typography>
          <Typography variant="body2" color="text.secondary">
            잠시만 기다려주세요.
          </Typography>
        </Paper>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      bgcolor="background.default"
      p={2}
    >
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center', maxWidth: 500 }}>
        {success ? (
          <>
            <CheckCircle sx={{ fontSize: 80, color: 'success.main', mb: 2 }} />
            <Typography variant="h5" gutterBottom color="success.main">
              {actionType} 완료!
            </Typography>
            <Typography variant="body1" paragraph>
              이메일 인증이 성공적으로 완료되었습니다.
              이제 모든 기능을 정상적으로 사용하실 수 있습니다.
            </Typography>
            <Box sx={{ mt: 3, display: 'flex', gap: 2, justifyContent: 'center' }}>
              <Button variant="contained" onClick={handleGoHome}>
                홈으로 이동
              </Button>
              <Button variant="outlined" onClick={handleGoLogin}>
                로그인하기
              </Button>
            </Box>
          </>
        ) : (
          <>
            <Error sx={{ fontSize: 80, color: 'error.main', mb: 2 }} />
            <Typography variant="h5" gutterBottom color="error.main">
              {actionType} 실패
            </Typography>
            <Alert severity="error" sx={{ mb: 3 }}>
              {error}
            </Alert>
            <Typography variant="body2" paragraph color="text.secondary">
              문제가 지속되면 고객지원팀에 문의해주세요.
            </Typography>
            <Box sx={{ mt: 3, display: 'flex', gap: 2, justifyContent: 'center' }}>
              <Button variant="contained" onClick={handleGoHome}>
                홈으로 이동
              </Button>
              <Button variant="outlined" onClick={handleGoLogin}>
                다시 시도
              </Button>
            </Box>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default EmailActionPage; 